import { useCallback } from 'react';
import { PolicyTemplate, PolicyTemplateDetails } from '../../../../types/policies';
import { usePut, UsePutParams } from '../../../../api';
import { NullableFields, RequiredFieldsOf } from '../../../../types/types';
import { TEMPLATES_BASE_URL } from '../consts';

type RequiredPolicyTemplateDetailsFields = RequiredFieldsOf<PolicyTemplateDetails>;

type MinimalPolicyTemplateDetails = Pick<PolicyTemplateDetails, RequiredPolicyTemplateDetailsFields>;

export type UpdatePolicyTemplateBody = Partial<MinimalPolicyTemplateDetails> &
    NullableFields<Partial<Omit<PolicyTemplateDetails, RequiredPolicyTemplateDetailsFields>>>;

interface ErrorResponse {
    error: string;
    templateId: PolicyTemplate['id'];
    templateDetails: Partial<PolicyTemplateDetails>;
}

export type UseUpdatePolicyTemplateParams = UsePutParams<UpdatePolicyTemplateBody, PolicyTemplate, ErrorResponse>;

export const useUpdatePolicyTemplate = (params: UseUpdatePolicyTemplateParams) => {
    const { put, loading, error } = usePut<UpdatePolicyTemplateBody, PolicyTemplate, ErrorResponse>(params);

    const updatePolicyTemplate = useCallback(
        (templateId: PolicyTemplate['id'], details: UpdatePolicyTemplateBody) =>
            put(`${TEMPLATES_BASE_URL}/${templateId}`, details),
        [put]
    );

    return {
        loading,
        error,
        updatePolicyTemplate
    };
};
